import React from 'react';
import { Play, ArrowRight, Smartphone } from 'lucide-react';

const CTA = ({ language }) => {
  const texts = {
    en: {
      title: 'Ready to Explore Amazing Games?',
      subtitle: 'Start browsing our collection of top mobile games and apps today',
      cta: 'Browse Collection',
      features: [
        'Popular Games',
        'Latest Apps',
        'Safe Access',
        '24/7 Available'
      ]
    },
    sl: {
      title: 'Pripravljeni raziskovati neverjetne igre?',
      subtitle: 'Začnite brskati po naši zbirki najboljših mobilnih iger in aplikacij še danes',
      cta: 'Prebrskaj zbirko',
      features: [
        'Priljubljene igre',
        'Najnovejše aplikacije',
        'Varen dostop',
        '24/7 na voljo'
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-5" className="py-20 bg-gradient-to-br from-blue-600 to-indigo-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
              <Smartphone className="w-10 h-10 text-white" />
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              {t.title}
            </h2>
            
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
              {t.subtitle}
            </p>
          </div>

          <div className="flex justify-center items-center mb-12">
            <a href="/s" className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-blue-50 transition-colors duration-200 flex items-center space-x-2 shadow-lg">
              <Play className="w-6 h-6" />
              <span>{t.cta}</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-blue-100">
            {t.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-300 rounded-full"></div>
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
